import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { SchedulesComponent } from "./schedules/schedules.component";
import { DataComponent } from "./data/data.component";
import { UserDataEditPageComponent } from "./data/user-data-edit-page/user-data-edit-page.component";
import { SchedulingComponent } from "./scheduling.component";
import { TasksComponent } from "./tasks/tasks.component";
import { AuthGuard } from "../services/permission/permissions.service";
import { ScheduleComponent } from "./schedules/schedule/schedule.component";


const routes: Routes = [
  {
    path: "scheduling",
    component: SchedulingComponent,

    children: [
      {
        path: "schedules",
        component: SchedulesComponent,
        canActivate: [AuthGuard]
      },
      {
        path: "schedule",
        component: ScheduleComponent,
        canActivate: [AuthGuard]
      },
      {
        path: "user-data",
        component: DataComponent,
        canActivate: [AuthGuard]
      },
      // TASK-177 — Full-page UserData editor. /new for create (with optional
      // ?type=… query for pre-fill), /:id/edit for editing an existing row.
      {
        path: "user-data/new",
        component: UserDataEditPageComponent,
        canActivate: [AuthGuard]
      },
      {
        path: "user-data/:id/edit",
        component: UserDataEditPageComponent,
        canActivate: [AuthGuard]
      },
      {
        path: "tasks",
        component: TasksComponent,
        canActivate: [AuthGuard]
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SchedulingRoutingModule {}
